import React from "react";
import { FieldComponent } from "./Field";
import FieldGroup from "./FieldGroup";

export const CustomComponent = ({ fields, onFieldChange, data, fieldsResult, removeKey,selectedClass, waiverEmail}) => (
  <>
    {fields &&
      fields.map((field, index) => {
        switch (field.type) {
          case "field":
            return (
              <React.Fragment key={index}>
                <FieldComponent
                  field={field}
                  onFieldChange={onFieldChange}
                  data={data}
                  fieldsResult={fieldsResult}
                  removeKey={removeKey}
                  selectedClass={selectedClass}
                  waiverEmail={waiverEmail}
                />
              </React.Fragment>
            );
          case "fieldGroup":
            return (
              <React.Fragment key={index}>
                <FieldGroup
                  field={field}
                  onFieldChange={onFieldChange}
                  data={data}
                  fieldsResult={fieldsResult}
                  waiverEmail={waiverEmail}
                />
              </React.Fragment>
            );
          default:
            return null;
        }
      })}
  </>
);
